import { VueModule } from '@Foundation/utilities';
import SuccessModal from './code/Scripts/components/success-modal';

export default VueModule({
  components: {
    SuccessModal
  }
});
